import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { Async } from "react-select"
import { quoteFields } from "../../common/search-filter/search/quotesFilters"
import { isError } from "../../state/helpers/Error"
import QuoteService from "../../state/quote/QuoteService"
import searchService from "../../state/search/SearchService"
import QuoteStatusBadge from "../status.component"


type OwnProps = {
    onChange: (id: string, label: string) => void
    id: string
}

const QuoteSelectionComponent = (props: OwnProps) => {

    const [selectedOptions, setSelectedOptions] = useState({
        id: "",
        label: ""
    })

    useEffect(() => {
        loadInitialQuote(props.id)
    }, [])

    const loadQuotes = (input, callback) => {

        const postData = {
            keywords: input + "*",
            objects: ["quotes"],
            fields: quoteFields,
            pageSize: 50,
            activePage: 1,
            sortByField: "identifier",
            sortAsc: false,
            filters: {},
            lightResult: true,
        }

        searchService.listingSearch(postData).then(res => {
            if (!isError(res)) {
                const opt = res.data.map(quote => {
                    return {value: quote.id, projectId: quote["projectId"],label: <div id="statusBadgeSelection">
                        <b className={"mr-2"}>{quote["identifier"]}</b>{"- " + quote["projectTitle"]}
                        <p>
                            <small>
                                <QuoteStatusBadge
                                    status={quote["status"]}
                                    className={"mr-2"}
                                />
                                {"$" + quote["totalAmount"]}
                            </small>
                        </p>
                    </div>}
                })
                callback(null, {
                    options: opt,
                    complete: false,
                })
            }
        })
    }

    const loadInitialQuote = (quoteId: string) => {
        if (quoteId) {
            QuoteService.get(quoteId).then(res => {
                if (!isError(res)) {
                    setSelectedOptions({
                        id: res.getId(),
                        label: res.getIdentifier()
                    })
                }
            })
        }
    }

    const handleChange = (selectedOptions) => {
        let quoteId = ""
        let label = ""
        let projectId = ""
        if (selectedOptions) {
            quoteId = selectedOptions.value
            label = selectedOptions.label
            projectId = selectedOptions.projectId
        }
        props.onChange(quoteId, projectId)
        setSelectedOptions({
            id: quoteId,
            label: label
        })
    }

    return (
        <Async
            multi={false}
            ignoreAccents={false}
            filterOptions={false}
            value={selectedOptions}
            onChange={handleChange}
            onBlurResetsInput={false}
            loadOptions={loadQuotes}
        />
    )
}

export default injectIntl(QuoteSelectionComponent)


// WEBPACK FOOTER //
// ./src/quote/components/QuoteSelectionComponent.tsx